import { ChecklistItem } from "../types/checklist.types";

export const CHECKLIST_ITEM_STEPS_AMOUNT = {
    [ChecklistItem.CLEANING_PROCEDURE]: 1,
    [ChecklistItem.CONTAINER_DONE]: 1,
    [ChecklistItem.POST_OPERATION_CHECKLIST]: 2,
    [ChecklistItem.PRE_OPERATION_CHECKLIST]: 3
};
